import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Button } from '@mui/material';
import userApi from '../../api/userApi';
import { useParams, useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/dateFormatter';

export default function UtenteDetailPage() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    userApi.get(id).then(r => setUser(r.data));
  }, [id]);

  if (!user) return <div>Loading...</div>;
    console.log("utente: ",user);
  return (
    <Container>
      <Typography variant="h4">Utente {user.username}</Typography>
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography>Email: {user.email}</Typography>
          <Typography>Profile: {user.profile}</Typography>
          <Typography>Tipo contratto: {user.contratto ? user.contratto.tipocontratto.tipo : '—'}</Typography>
          <Typography>Canone annuo contratto: {user.contratto ? user.contratto.canoneAnnuo : '—'}</Typography>
          <Typography>Scadenza contratto: {user.contratto ? formatDate(user.contratto.dataFine): '—'}</Typography>
          <Typography>Enabled: {user.enabled ? 'SI' : 'NO'}</Typography>
          <Button sx={{ mt: 2 }} onClick={() => navigate(`/users/${id}/edit`)}>Modifica</Button>
        </CardContent>
      </Card>
 {/* --- CREA CONTRATTO SE NON ESISTE --- */}
{user.contrattoId == null && (
<Button
  variant="contained"
  sx={{ mt: 2 }}
  onClick={() => navigate(`/contratti/create?utenteId=$${id}&redirect=/users/${id}/edit`)}
>
  Crea Contratto
</Button>
)}
{user.contrattoId != null && (
<Button
  variant="contained"
  sx={{ mt: 2 }}
  onClick={() => navigate(`/contratti/${user.contrattoId}`)}
>
  Visualizza Contratto
</Button>
)}
    </Container>
  );
}